import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let swipers = document.querySelectorAll('.noss_teaser2.slider .swiper');

    for (let i = 0; i < swipers.length; ++i) {
        let prevEl = swipers[i].closest('.noss_teaser2').querySelector('.btn-prev');
        let nextEl = swipers[i].closest('.noss_teaser2').querySelector('.btn-next');

        let mySwiper = new Swiper(swipers[i], {
            slidesPerView: 1.35,
            spaceBetween: 30,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            on: {
                init: function () {
                    if (window.lazyLoadInstance) {
                        window.lazyLoadInstance.update();
                    }
                },
            },
        });

    }
}